import { connect } from 'react-redux'
import { required } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'

import { doSave } from '../actions'
import { selectFormFields, selectNextPage } from '../selectors'

import CustomerInformationFormView from './view'

const validators = {
  numberOfEmployeesInput: required,
  customHelpInput: required,
  industryInput: required,
}

const select = state => ({
  initialValues: selectFormFields(state),
  validators,
  nextPage: selectNextPage(state),
})

const perform = {
  onSave: doSave,
}

export default connect(select, perform)(
  withFormFields(CustomerInformationFormView)
)
